// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__OGgJG","title":"Images45_title__2egUe","images":"Images45_images__19l-t"};